























































































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* components */
import DoughnutGraph from '@/app/components/Profit/DoughnutGraph.vue'
import PieGraph from '@/app/components/Profit/PieGraph.vue'
import ProfitListHeader from '@/app/components/Profit/ProfitListHeader.vue'
import ProfitList from '@/app/components/Profit/ProfitList.vue'
/* plugin */
import * as ChartDatalabels from 'chartjs-plugin-datalabels'
import CommonClass from '@/app/module/common'

/* global */
let totalArea: number = 0

@Component({
  components: {
    DoughnutGraph,
    PieGraph,
    ProfitListHeader,
    ProfitList
  }
})
export default class Profit extends Vue {
  /* 表示非表示 */
  private renderList: boolean = false
  private allGraphData: boolean = false
  private areaGraphData: boolean = false
  private factorGraphData: boolean = false
  /* クラス */
  private isActiveClass: string = '2'
  /* データ */
  private displayListData: any[] = []
  private notFoundMessage: boolean = false
  private risk: string = '全情報'
  public total: string = '0'
  public allChartData: any = {}
  public areaLossChartData: any = {}
  public factorLossChartData: any = {}
  public allChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    layout: {
      padding: {
        top: 40,
        left: 20,
        bottom: 40,
        right: 20
      }
    },
    tooltips: {
      enabled: false
    },
    plugins: [
      ChartDatalabels
    ]
  }
  public areaLossOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul>')
      for (var i = 0; i < chart.legend.legendItems.length; i++) {
        text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].fillStyle + '"></span><span>')
        if (chart.legend.legendItems[i]) {
          text.push(CommonClass.stringCut(chart.legend.legendItems[i].text) + '（' + chart.data.datasets[0].data[i].toLocaleString() + 'ha）')
        }
        text.push('</span></li>')
      }
      text.push('</ul>')

      return 1 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 0,
        bottom: 20,
        right: 20
      }
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem: any, data: any) {
          return data.labels[tooltipItem.index] +
                ': ' +
                data.datasets[0].data[tooltipItem.index].toLocaleString() +
                'ha'
        }
      }
    }
  }
  public factorLossOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false
    },
    legendCallback: function (chart: any) {
      var text = []
      text.push('<ul>')
      for (var i = 0; i < chart.legend.legendItems.length; i++) {
        text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].fillStyle + '"></span><span>')
        if (chart.legend.legendItems[i]) {
          text.push(CommonClass.stringCut(chart.legend.legendItems[i].text) + '（' + chart.data.datasets[0].data[i].toLocaleString() + 'ha）')
        }
        text.push('</span></li>')
      }
      text.push('</ul>')

      return 2 + text.join('')
    },
    layout: {
      padding: {
        top: 20,
        left: 0,
        bottom: 20,
        right: 20
      }
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem: any, data: any) {
          return data.labels[tooltipItem.index] +
                ': ' +
                data.datasets[0].data[tooltipItem.index].toLocaleString() +
                'ha'
        }
      }
    }
  }
  // 内側の文字
  private textInChart: any = {
    beforeDraw: function (chart: any) {
      if (totalArea !== 0) {
        var width = chart.chart.width
        var height = chart.chart.height
        var ctx = chart.chart.ctx

        ctx.restore()
        // 文字
        ctx.font = '15px sans-serif'
        ctx.textBaseline = 'middle'
        var text = '全体圃場面積'
        var textX = Math.round((width - ctx.measureText(text).width) / 2)
        var textY = height / 2 - 10
        ctx.fillText(text, textX, textY)

        ctx.font = 'bold 22px sans-serif'
        var text2 = totalArea.toLocaleString() + 'ha'
        var textX2 = Math.round((width - ctx.measureText(text2).width) / 2)
        var textY2 = height / 2 + 15
        ctx.fillText(text2, textX2, textY2)
        ctx.save()
      }
    }
  }

  @Prop() graphData!: any
  @Prop() listData!: any
  @Prop() riskListData!: any

  created () {
    this.displayListData = this.listData
    this.createGraphData()

    totalArea = this.graphData.total_field_area
  }

  /* 円グラフデータ作成 */
  public createGraphData () {
    // 全体圃場面積
    if (this.graphData.total_harvest_area === 0 && this.graphData.total_loss_area === 0) {
      this.allGraphData = true
    }

    this.allChartData = {
      id: 1,
      labels: ['全体収穫量', '全体欠損量'],
      datasets: [
        {
          data: [this.graphData.total_harvest_area, this.graphData.total_loss_area],
          backgroundColor: ['#FCEFE4', '#F5F5F5'],
          datalabels: {
            enabled: true,
            color: ['#E86161', '#2C2C2C'],
            textAlign: 'center',
            font: {
              size: '20',
              weight: 'bold'
            },
            formatter: function (value: any, ctx: any) {
              var index = ctx.dataIndex
              var label = ctx.chart.data.labels[index]
              return label + '\n' + value.toLocaleString() + 'ha'
            }
          }
        }
      ]
    }

    // 地区別欠損面積
    this.areaLossChartData = {
      id: 2,
      labels: this.createAreaLossLabel(),
      datasets: [
        {
          data: this.createAreaLossData(),
          backgroundColor: ['#FCEFE4', '#EAFCE4', '#E4F9FC', '#F5F5F5'],
          borderWidth: 0,
          datalabels: {
            color: '#2C2C2C',
            textAlign: 'center',
            labels: {
              title: {
                font: {
                  weight: 'bold',
                  size: 13
                }
              }
            },
            formatter: (value: any, ctx: any) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map((data: any) => {
                sum += data
              })
              let percentage = (value * 100 / sum)

              if (percentage > 5) {
                return percentage.toFixed(0) + '%'
              } else {
                return ''
              }
            }
          }
        }
      ]
    }

    // 欠損要因内訳
    this.factorLossChartData = {
      labels: this.createLossLabel(),
      datasets: [
        {
          data: this.createLossData(),
          backgroundColor: ['#FCEFE4', '#EAFCE4', '#E4F9FC', '#F0E4FC', '#F5F5F5'],
          borderWidth: 0,
          datalabels: {
            color: '#2C2C2C',
            textAlign: 'center',
            labels: {
              title: {
                font: {
                  weight: 'bold',
                  size: 13
                }
              }
            },
            formatter: (value: any, ctx: any) => {
              let sum = 0
              let dataArr = ctx.chart.data.datasets[0].data
              dataArr.map((data: any) => {
                sum += data
              })
              let percentage = (value * 100 / sum)

              if (percentage > 5) {
                return percentage.toFixed(0) + '%'
              } else {
                return ''
              }
            }
          }
        }
      ]
    }
  }

  /* 地区別欠損面積ラベル */
  private createAreaLossLabel () {
    let areaLoss = this.graphData.harvest_area_summaries
    let areaLossLabel = []

    for (var i in areaLoss) {
      if (areaLoss[i].harvest_area !== 0 && areaLoss[i].harvest_area !== null) {
        areaLossLabel.push(areaLoss[i].district_name)
      }
    }

    if (areaLossLabel.length === 0) {
      this.areaGraphData = true
    }

    return areaLossLabel
  }

  /* 地区別欠損面積データ */
  private createAreaLossData () {
    let areaLoss: any = this.graphData.harvest_area_summaries
    let areaLossData: number[] = []

    for (var i in areaLoss) {
      areaLossData.push(areaLoss[i].harvest_area)
    }

    areaLossData.sort(
      function (a:number, b: number) {
        return b - a
      }
    )

    if (areaLossData.length === 0) {
      this.areaGraphData = true
    }

    return areaLossData
  }

  /* 欠損要因ラベル */
  private createLossLabel () {
    let loss = this.graphData.harvest_loss_summaries
    let lossLabel = []

    for (var i in loss) {
      if (loss[i].harvest_loss_area !== 0 && loss[i].harvest_loss_area !== null) {
        lossLabel.push(loss[i].loss_factor)
      }
    }

    if (lossLabel.length === 0) {
      this.factorGraphData = true
    }

    return lossLabel
  }

  /* 欠損要因データ */
  private createLossData () {
    let loss = this.graphData.harvest_loss_summaries
    let lossData = []

    for (var i in loss) {
      lossData.push(loss[i].harvest_loss_area)
    }

    lossData.sort(
      function (a:number, b: number) {
        return b - a
      }
    )

    if (lossData.length === 0) {
      this.factorGraphData = true
    }

    return lossData
  }

  /* リストタブの切り替え */
  private changeListTab (val: string) {
    this.isActiveClass = val
    this.$emit('change-list-type', val)
  }

  /* リスト表示切り替え */
  public changeList (listData: any) {
    this.displayListData = listData
  }

  /* リスト絞り込み */
  private refineList () {
    this.displayListData = []

    if (this.risk === '全情報') {
      this.displayListData = this.listData
    }

    for (var i in this.listData) {
      if (this.listData[i].loss_factor.indexOf(this.risk) !== -1) {
        this.displayListData.push(this.listData[i])
      }
    }

    if (this.displayListData.length === 0) {
      this.notFoundMessage = true
    } else {
      this.notFoundMessage = false
    }
  }
}
